import { render } from "./MainFrame.vue?vue&type=template&id=cc63ab86&scoped=true"
import script from "./MainFrame.vue?vue&type=script&lang=js"
export * from "./MainFrame.vue?vue&type=script&lang=js"

import "./MainFrame.vue?vue&type=style&index=0&id=cc63ab86&scoped=true&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc63ab86"]])

export default __exports__